// extracted by mini-css-extract-plugin
export default {"captureNoteEditor":"CaptureNoteEditor_captureNoteEditor__XPT2X","text":"CaptureNoteEditor_text__k-Ylx","editing":"CaptureNoteEditor_editing__-3hb7"};